import React from "react"
import styles from "./Buttons.module.scss"


export const StartButton = () => {
    return (
        <button className={styles.startBtn}>Начать</button>
    )
}